export default "__VITE_ASSET__DX$Vtk5r__"